import React, { useMemo } from "react";
import styles from "./index.module.scss";
import classes from "classnames";
import { UserInfo } from "../../types";
import vipTagImg from "./images/vip-tag.png";
import { login, logout } from "../../utils";
import Popup from "../popup";

export interface UserPassportProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  userInfo: UserInfo | null;
}

const UserPassport = ({ userInfo, className }: UserPassportProps) => {
  const isVip = useMemo(() => {
    return !!userInfo?.vip_infos.length;
  }, [userInfo]);

  return (
    <div className={classes(styles.userPassport, className)}>
      {!!userInfo?.is_login ? (
        <>
          <Popup
            className={styles.userInfo}
            content={
              <div className={styles.menus}>
                <div className={styles.menu} onClick={() => logout()}>
                  退出
                </div>
              </div>
            }
          >
            <div className={styles.avatar}>
              <img
                className={styles.headshot}
                src={
                  userInfo?.avatar ||
                  `https://api.dicebear.com/6.x/bottts/png?seed=${
                    userInfo?.nickname || "guest"
                  }`
                }
                alt=""
              />
              {isVip && (
                <img className={styles.vipTag} src={vipTagImg} alt="" />
              )}
            </div>

            <div className={styles.username}>{userInfo?.nickname}</div>
            <div className={styles.dropdown} />
          </Popup>
        </>
      ) : (
        <div className={styles.login} onClick={() => login()}>
          登陆
        </div>
      )}
    </div>
  );
};

export default UserPassport;
